var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 26",
    style: {
      enableBackground: "new 0 0 88 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,25V1h6.5v19.4h8.2V25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.6,13.7c0,3.8-0.1,4.8-0.3,5.7c-1.1,3.9-5.1,6.2-10.6,6.2c-4.2,0-7.2-1.3-8.6-3.8c-0.9-1.7-1-2.5-1-7.6V1 h6.5v13.5c0,3.5,0,3.8,0.4,4.7c0.5,1.2,1.7,1.9,3.3,1.9c1.4,0,2.6-0.6,3.2-1.6c0.7-1,0.8-1.5,0.8-5V1h6.3V13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M55.3,5.5h-8.6v5.1h7.9V15h-7.9v5.4h9.1V25H40.3V1h15V5.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1050C",
    className: "st1",
    d: "M87.5,22.1c0,2-1.6,3.6-3.5,3.6c-1.9,0-3.6-1.6-3.6-3.5c0-1.9,1.7-3.6,3.5-3.6C86,18.6,87.5,20.1,87.5,22.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76,6.4c-2.2-0.9-4.1-1.3-6-1.3c-3.9,0-5.8,2.3-5.8,7.7c0,4.9,1.9,8.1,4.9,8.1c1.2,0,2-0.2,3.1-0.8v-7.6h6v9.6 c-3.4,2.3-6.9,3.5-10,3.5c-6.7,0-10.6-4.6-10.6-12.6c0-8.2,4.2-12.4,12-12.4c2.6,0,4.9,0.3,7.6,1.1L76,6.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8406f476ba216384a116a8dba548e5bb.svg";
export { ForwardRef as ReactComponent };